import { createSelector } from 'reselect';
import { get } from 'stash/utils';

export const getProduct = (state, props) => {
  return get(props, 'match.params.product', '');
};

export const selectProduct = createSelector(getProduct, product => {
  return product;
});
